import React from "react";
import "./Dashboard.css";
import CardItem from "../CardItem/CardItem";

import useIsMobile from "../../hooks/useIsMobile";

import searchIcon from "../../assets/new-images/search-icon.svg";

const Dashboard = ({
    icon,
    title,
    subtitle,
    description,
    headline,
    narration,
    categories = [],
    categoryCards = [],
    cards = [],
    cardsData = [],
    actions = null,
    promptLibraryText = null,
    cardsTitle = null,
    cardsSubtitle = null,
    className = "",
    onPromptClick,
    activeCategory,
    filteredPrompts = [],
    inputValue = "",
    gridColumns = 3,
}) => {
    const isMobile = useIsMobile();

    // Same logic as CPC: use filteredPrompts when typing, else active category prompts
    const resolvedCategories = inputValue ? filteredPrompts : categories;
    const activePrompts = activeCategory
        ? (resolvedCategories.find(c => c.label === activeCategory)?.prompts || [])
        : [];

    return (
        <div className={`dashboard-hero ${className}`}>
            {icon && (
                <div className="dashboard-main-icon">
                    <img src={icon} alt="dashboard-icon" />
                </div>
            )}

            {title && (
                <div className="dashboard-title">
                    {title}
                </div>
            )}

            {subtitle && (
                <div className="dashboard-subtitle">
                    {subtitle}
                </div>
            )}

            {description && (
                <div className="dashboard-description">
                    {description}
                </div>
            )}

            {headline && (
                <div className="di-pill-container">
                    <div className="di-pill">
                        <span className="di-pill-dot"></span>
                        <span className="di-pill-text">{headline}</span>
                    </div>
                </div>
            )}

            {narration && (
                <div className="di-info-box">
                    {String(narration)
                        .split("\n")
                        .map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                        ))}
                </div>
            )}
            {categoryCards.length > 0 && (
                <div className="dashboard-category-cards-container">
                    {(cardsTitle || promptLibraryText) && (
                        <div className="dashboard-cards-header">
                            <div className="dashboard-cards-header-left">
                                {cardsTitle && <h3 className="dashboard-cards-title">{cardsTitle}</h3>}
                                {cardsSubtitle && <p className="dashboard-cards-subtitle">{cardsSubtitle}</p>}
                            </div>
                            {promptLibraryText && (
                                <div className="dashboard-right-action">
                                    <button className="dashboard-prompt-library-link">
                                        {promptLibraryText}
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                    <div className="dashboard-category-cards-section">
                        {categoryCards.map((card, index) => (
                            <div key={index} className={`dashboard-category-card-wrapper ${activeCategory === card.heading ? "active-card" : ""
                                }`}>
                                <CardItem
                                    icon={card.icon}
                                    title={card.heading}
                                    subtitle={card.subtitle}
                                    prompts={card.items || []}
                                    onPromptClick={card.onItemClick}
                                    onClick={card.onCardClick}
                                    isMobile={isMobile}
                                    highlight={card.highlight}
                                    theme={card.theme}
                                />
                                {/* Inline prompt list — only on mobile, only below the categories card (index 1) */}
                                {isMobile && index === 1 && card.items && activePrompts.length > 0 && onPromptClick && (
                                    <div className="cpc-inline-prompt-list cpc-inline-dashboard-prompt-list">
                                        {activePrompts.map((prompt, i) => (
                                            <button
                                                key={i}
                                                type="button"
                                                className="cpc-prompt-item"
                                                onClick={() => onPromptClick(prompt)}
                                            >
                                                <span className="cpc-prompt-icon">
                                                    <img src={searchIcon} alt="search" />
                                                </span>
                                                {prompt}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {cardsData && (Object.keys(cardsData).length > 0 || cardsData.length > 0) && (
                <div className={`dashboard-cards-wrapper grid-cols-${gridColumns}`}>
                    {(cardsTitle || promptLibraryText) && categoryCards.length === 0 && (
                        <div className="dashboard-cards-header">
                            <div className="dashboard-cards-header-left">
                                {cardsTitle && <h3 className="dashboard-cards-title">{cardsTitle}</h3>}
                                {cardsSubtitle && <p className="dashboard-cards-subtitle">{cardsSubtitle}</p>}
                            </div>
                            {promptLibraryText && (
                                <div className="dashboard-right-action">
                                    <button className="dashboard-prompt-library-link">
                                        {promptLibraryText}
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                    <div className={`dashboard-cards-container grid-cols-${gridColumns}`}>
                        {(Array.isArray(cardsData) ? cardsData : Object.values(cardsData)).map((card, index) => (
                            <div key={index} className="dashboard-card-wrapper">
                                <CardItem
                                    {...card}
                                    onPromptClick={onPromptClick}
                                    isMobile={isMobile}
                                    theme={card.theme}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {cards.length > 0 && (
                <div className="cards card-container">
                    {cards}
                </div>
            )}

            {actions && (
                <div className="dashboard-actions">
                    {actions}
                </div>
            )}
        </div>
    );
};

export default Dashboard;
